import styled from '@emotion/styled';

export const Wrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;
